import React, { useState } from 'react';
import { Upload, message, Progress, Typography, Button, Space, Form } from 'antd';
import { UploadOutlined } from '@ant-design/icons';
import { apiCall } from '../utils/Api';

const { Dragger } = Upload;
const { Text } = Typography;


export default function ChunkUploader(props) {

    const { is_button = false, chunk_size = 1 * 1024 * 1024, label = "Upload File", error_text = "Please try again.", uploading_text = "Uploading...", success_text = "Upload complete!" } = props;

    const [uploading, setUploading] = useState(false);
    const [progress, setProgress] = useState(0);
    const [status, setStatus] = useState('idle');

    const sendChunk = (_file, _filename, _filesize, _start = 0, onSuccess) => {
        if (_start >= _filesize) {
            message.success("Upload complete!");
            setStatus('success');
            setUploading(false);
            onSuccess("ok");
            return;
        }

        const end = Math.min(_start + chunk_size, _filesize);
        const chunk = _file.slice(_start, end);

        apiCall("simple_upload/send_chunk", { filename: _filename, filesize: _filesize, file: chunk, start: _start, end: end }, (_s, _r) => {
            if (_s) {
                const percentage = Math.round((end / _filesize) * 100);
                setProgress(percentage);
                sendChunk(_file, _filename, _filesize, end, onSuccess);
            } else {
                message.error(`Upload failed at chunk ${_start}: ${_r.error}`);
                setStatus('error');
                setUploading(false);
            }
        });
    };

    const sendFileInfo = ({ file, onSuccess, onError }) => {
        const _filesize = file.size;
        const _filename = file.name;
        setUploading(true);
        setProgress(0);
        setStatus('uploading');

        apiCall("simple_upload/set_current_file_info", { filename: _filename, filesize: _filesize }, (_s, _r) => {
            if (_s) {
                sendChunk(file, _filename, _filesize, 0, onSuccess);
            } else {
                message.error(`Failed to initiate upload: ${_r.error}`);
                setStatus('error');
                setUploading(false);
                onError(_r.error);
            }
        });
    };



    if (is_button) {

        return (
            <>
                <Form layout="vertical">
                    <Form.Item help={<>
                        {(status === 'error' && <Text type="danger"><small>{error_text}</small></Text>)}
                        {(status === 'uploading' && <Text><small>{uploading_text} {progress}%</small></Text>)}
                        {(status === 'success' && <Text type="success"><small>{success_text}</small></Text>)}
                    </>}>
                        <Upload disabled={uploading} customRequest={sendFileInfo} showUploadList={false}>
                            <Button icon={<UploadOutlined />}>{label}</Button>
                        </Upload>
                    </Form.Item>
                </Form>

            </>
        )
    }

    return (
        <>
            <Dragger
                customRequest={sendFileInfo}
                showUploadList={false}
                disabled={uploading}
                accept="*"
            >

                <div><UploadOutlined style={{ "fontSize": "20px" }} /></div>
                <p className="ant-upload-text">{label}</p>
                {(uploading && <div style={{ "padding": "0px 10px" }}><div><Text>{uploading_text}</Text></div><div><Progress percent={progress} size="small" /></div></div>)}
                {(status === 'error' && <Text type="danger">{error_text}</Text>)}
                {(status === 'success' && <Text type="success">{success_text}</Text>)}

            </Dragger>


        </>
    );
}
